(() => {
  const sourceText = 'Review collected from another provider';
  const amazonLabel = 'Verified Purchase from Amazon';
  const marker = 'data-pizzannu-amazon-label';

  const appendAmazonLabel = (root) => {
    if (!root || !root.querySelectorAll) return;

    const candidates = Array.from(root.querySelectorAll('*')).filter((element) => {
      if (element.getAttribute(marker) === 'true') return false;
      if (!element.textContent.includes(sourceText)) return false;
      return !Array.from(element.children).some((child) => child.textContent.includes(sourceText));
    });

    candidates.forEach((element) => {
      const label = document.createElement('span');
      label.className = 'pizzannu-amazon-review-label';
      label.textContent = ` · ${amazonLabel}`;
      element.appendChild(label);
      element.setAttribute(marker, 'true');
    });
  };

  const start = () => {
    appendAmazonLabel(document);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) appendAmazonLabel(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
